<template>
	<div>        
		<div>
			<!--Borrar -->
			<div :class="[mostrarEliminar ? 'span-eliminar': 'fondo-borrar']"
                    @click="mostrarColumnaEliminar"
                    class="row d-block d-lg-none">
				<div class="col-12 text-center text-white py-2">
					<i class="icon-trazado-1162"></i>
					<span class="borrar-texto">Borrar de la lista de productos</span>
				</div>
			</div>
            <!-- tabla -->
			<div class="row" style="padding-bottom: 150px;">
				<table class="table fondo-tabla table-sm" id="tblCarrito" ref="tablaCarrito">
					<thead class="fondo-tabla-head fuente-tabla-head cabecera">
						<tr class="d-none d-md-table-row">
							<th
								:class="[mostrarEliminar ? 'd-table-cell': '']"
								@click="mostrarEliminarTodosOpen()"
								class="d-none d-lg-table-cell text-center td-center"
							>
								<span class="circle-trash-vaciar-carrito p-1">
									<i class="icon-trazado-1162"></i>
								</span>
							</th>
							<th class>Producto</th>
							<th class="d-none d-lg-table-cell">Laboratorio</th>
							<th class="d-none d-md-table-cell text-right">Precio</th>
							<th class="text-center">Cantidad</th>
							<th class="d-none d-md-table-cell text-right">Importe</th>
						</tr>
					</thead>
					<tbody v-if="this.articulos.length <= 0">
						<tr>
							<td colspan="6">
								<b-alert class="col-12" show variant="warning">
									<div class="d-flex justify-content-center">Su carrito se encuentra vacío.</div>
								</b-alert>
							</td>
						</tr>
					</tbody>
					<tbody>
						<tr :key="articulo.codArticulo" v-for="(articulo, index) in articulos">
							<td
								:class="{'d-table-cell': mostrarEliminar}"
								@click="mostrarEliminarOpen(articulo)"
								class="d-none d-lg-table-cell py-0 td-center text-center"
							>
								<span class="circle-trash p-1">
									<i class="icon-trazado-1162 icon-trash"></i>
								</span>
							</td>
							<td @click="verDetalle(articulo.codArticulo)" class="py-0 td-center">
								<div class="row p-0 m-0">
									<span class="fuente-tabla-producto m-0 p-0">{{articulo.descripcion}}</span>
								</div>
								<div class="row p-0 m-0">
									<span class="impuestos-iva-tabla p-0 m-0 mr-1 mt-1" v-if="articulo.iva > 0">&nbsp;</span>
									<span class="impuestos-ieps-tabla p-0 m-0 mr-1 mt-1" v-if="articulo.ieps > 0">&nbsp;</span>
									<span class="producto-sin-derecho-devolucion p-0 m-0 mr-1 mt-1" v-if="articulo.sinDerechoDevolucion">&nbsp;</span>
									<span class="impuestos-texto texto-producto-sin-devolucion" v-if="articulo.sinDerechoDevolucion">Producto sin derecho a devolución</span>
									<span class="producto-con-derecho-devolucion p-0 m-0 mr-1 mt-1" v-if="!articulo.sinDerechoDevolucion">&nbsp;</span>
									<span class="impuestos-texto texto-producto-con-devolucion" v-if="!articulo.sinDerechoDevolucion">Producto con derecho a devolución</span>
								</div>
								<div class="row">
									<div class="col-12 text-left">
										<span v-if="articulo.ofertado" class="fuente-tabla-precio d-block d-md-none">
											Precio: {{articulo.precioOfertado | format-number("0,0.00")}}
										</span>
										<span v-else-if="articulo.buenFin" class="fuente-tabla-precio d-block d-md-none">
											Precio: {{articulo.precioBuenFin | format-number("0,0.00")}}
										</span>
										<span v-else class="fuente-tabla-precio d-block d-md-none">
											Precio: {{articulo.precio | format-number("0,0.00")}}
										</span>
									</div>
								</div>
							</td>
							<td @click="verDetalle(articulo.codArticulo)"
								class="d-none fuente-tabla-laboratorio py-0 td-center d-lg-table-cell">
								{{articulo.laboratorio}}
							</td>
							<td @click="verDetalle(articulo.codArticulo)"
								class="d-none d-md-table-cell text-right fuente-tabla-precio py-0 td-center">
								<span v-if="articulo.ofertado">{{articulo.precioOfertado | format-number("0,0.00")}}</span>
								<span v-else-if="articulo.remate">{{articulo.precioRemate | format-number("0,0.00")}}</span>
								<span v-else-if="articulo.buenFin">{{articulo.precioBuenFin | format-number("0,0.00")}}</span>
								<span v-else>{{articulo.precio | format-number("0,0.00")}}</span>
							</td>
							<td class="td-center" style="width:180px;">
								<pm-input-number
									:indexSelected="index"
									:ref="'input' + index"
									:articulo="articulo"
									@agregarCantidad="agregarCantidad"
									@aumentar="aumentar"
									@disminuir="disminuir"
									@pressTab="pressTab"
									v-model="articulo.cantidad"
									:disabled = "ocultarBoton"
								></pm-input-number>
								<!-- <div class="row d-flex justify-content-end">
									<div class="col-12">
										<pm-input-number
											@aumentar="aumentar(articulo)"
											@blurInput="blurInput(articulo)"
											@disminuir="disminuir(articulo)"
											v-model="articulo.cantidad"
										></pm-input-number>
									</div>
								</div>
								<div class="row">
									<div class="col-12 text-right">
										<span
											class="fuente-tabla-importe d-block d-md-none"
										>Importe: {{ articulo.cantidad*articulo.precio | format-number("$0,0.00")}}</span>
									</div>
								</div>-->
							</td>
							<td
							
								@click="verDetalle(articulo.codArticulo)"
								class="d-none d-md-table-cell text-right fuente-tabla-importe py-0 td-center"
							>{{ articulo.cantidad * (articulo.ofertado ? articulo.precioOfertado : (articulo.remate ? articulo.precioRemate : articulo.buenFin ? articulo.precioBuenFin : articulo.precio)) | format-number("0,0.00")}}</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>

        <!-- eliminar 1 articulos de la tabla -->
        <b-modal @close="modalEliminarClose" centered id="modal-eliminar" no-close-on-backdrop title>
            <template v-slot:default>
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <p class="modal-titulo text-center">Desea quitar del carrito el producto:</p>
                            <p class="modal-articulo text-center">{{articuloSeleccionado.descripcion}}</p>
                        </div>
                        <div class="col-6">
                            <button
                                @click="modalEliminarClose"
                                class="link btn btn-block fuente-boton-cancelar text-white"
                            >Cancelar</button>
                        </div>
                        <div class="col-6">
                            <button
                                @click="eliminarArticulo"
                                class="link btn btn-block fuente-boton-eliminar text-white"
                            >Eliminar</button>
                        </div>
                    </div>
                </div>
            </template>
            <template v-slot:modal-footer>&nbsp;</template>
        </b-modal>
    
        <!-- enviar pedidos otros cedis -->
		<b-modal
				centered
				header-class="fondo-modal"
				id="modal-confirmacion-enviarPedido-otros-cedis"
				no-close-on-backdrop
				hide-header-close
				hide-footer
				size="md"
				>
				<div class="mt-3">
					<!-- <div v-if="mostrarFacturarPublicoGeneral" class="row mb-3">
						<div class="col-12 modal-enviar-texto d-flex text-center align-items-center justify-content-center vertical-align-center mt-2">
								<span class=" text-right">Facturar a: </span>
								
									<b-form-select class="w-75 ml-1 modal-enviar-texto"  v-model="facturarPublicoGeneral" 
													:options="opcionesFacturarPublicoGeneral"></b-form-select>
								
						</div>
					</div> -->
					<div class="row mb-3">
						<div class="col-12">
							<p class="modal-enviar-texto text-center">
							¿Desea enviar el pedido?</p>
						</div>
					</div>
					<div class="row m-2">
						<div class="col-12 col-md-6 col-lg-5 offset-lg-1 mb-3">
							
							<button
								@click="$bvModal.hide('modal-confirmacion-enviarPedido-otros-cedis')"
								:disabled="enviandoPedido"
								class="link btn btn-block fuente-boton-NoSurtir text-white"
							>No</button>
						</div>
						<div class="col-12 col-md-6 col-lg-5 mb-4">
							<button
								@click="abrirModalEnvioPedidoOtrosCedis"
								:disabled="enviandoPedido"
								class="link btn btn-block fuente-boton-SiSurtir text-white"
							>Sí</button>
						</div>
					</div>
				</div>
		</b-modal>

        <b-modal
            centered
            header-class="fondo-modal"
            id="modal-enviarPedido-otros-cedis"
            no-close-on-backdrop
			hide-footer
			hide-header-close
            size="lg"
            title>
            <template v-slot:default>
                <div class="mt-3">
                    <!-- otros cedis -->
                    <div class="row pb-4 m-1">
						<div class="col-12 text-right">
							<a class="cursor-pointer text-danger" role="button" @click="$bvModal.hide('modal-enviarPedido-otros-cedis')">
								<i class="fa fa-times"></i>
							</a>
						</div>
                        <div class="col-12">
                            <p class="modal-enviar-titulo pb-0 mb-0 text-center text-danger">Los productos listados no se encuentran disponibles en su CEDIS.</p>
                            <p class="modal-enviar-subtitulo text-center">
                                Si realiza su pedido de lunes a jueves se entregarán en un plazo máximo de 7 días, pedidos realizados de viernes a domingo máximo 11 días para su entrega.
                            </p>
                        </div>
                        <div class="col-12">
                            <table class="table table-sm mt-2 fondo-tabla">
                                <thead class="fondo-tabla-head fuente-tabla-head cabecera">
                                    <tr>
                                        <td>Producto</td>
                                        <td class="d-none d-md-table-cell">Laboratorio</td>
                                        <td class="d-none d-md-table-cell text-right">Cantidad</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-bind:key="item.codArticulo" v-for="item in cedisExternos">
                                        <td class="td-center">
                                            <div class="row p-0 m-0">
                                                <span class="modal-enviar-tabla m-0 p-0">{{item.nombreArticulo}}</span>
                                            </div>
                                            <div class="row">
                                                <div class="col-6 text-left">
                                                    <span class="modal-enviar-movil d-block d-md-none">Laboratorio: {{item.laboratorio}}</span>
                                                </div>
                                                <div class="col-6 text-right">
                                                    <span class="modal-enviar-movil d-block d-md-none">Cantidad: {{item.cantidad}}</span>
                                                </div>
                                            </div>
                                        </td>
                                        <td class="d-none d-md-table-cell">
                                            <span class="modal-enviar-tabla m-0 p-0">{{item.laboratorio}}</span>
                                        </td>
                                        <td class="d-none d-md-table-cell text-right">
                                            <span class="modal-enviar-tabla m-0 p-0">{{item.cantidad}}</span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div v-if="mostrarFacturarPublicoGeneral" class="row mb-3">
                        <div class="col-12 modal-enviar-texto d-flex text-center align-items-center justify-content-center vertical-align-center mt-2">
                            <span class=" text-right">Facturar a: </span>
                            <b-form-select 	class="w-75 ml-1 modal-enviar-texto"  
                                            v-model="facturarPublicoGeneral" 
                                            :options="opcionesFacturarPublicoGeneral"></b-form-select>
                                
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-12">
                            <div class="modal-enviar-texto text-center">
                                ¿Acepta que los productos se surtan de otros CEDIS
                            </div>
                            <div class="modal-enviar-texto text-center">
                                en los tiempos de entrega mencionados?
                            </div>
                        </div>
                    </div>
                    <div class="row m-3">
                        <div class="col-12 col-md-6 col-lg-5 offset-lg-1 mb-3">
                            <button
                                @click="surtir(false)"
                                class="link btn btn-block fuente-boton-NoSurtir text-white"
                            >No</button>
                        </div>
						<!-- @click="abrirModalConfirmacion" -->
                        <div class="col-12 col-md-6 col-lg-5 mb-4">
                            <button
								@click="surtir(true)"
                                class="link btn btn-block fuente-boton-SiSurtir text-white"
                            >Sí</button>
                        </div>
                    </div>
                </div>
            </template>
            <template v-slot:modal-footer>&nbsp;</template>
        </b-modal>

		<b-modal
            @close="modalEnviarPedidoConfirmacionClose"
            centered
            header-class="fondo-modal"
            id="modal-enviarPedido-otros-cedis-confirmacion"
            no-close-on-backdrop
			hide-footer
			hide-header-close
            size="lg"
            title>
            <template v-slot:default>
                <div class="mt-3">
                    <!-- otros cedis -->
                    <div class="row m-1">
                        <div class="col-12">
                            <h1 class=" modal-enviar-encabezado pb-0 mb-0 text-center text-danger">AVISO</h1>
							<p class="modal-enviar-subtitulo">
                                Estimado cliente
                            </p>
							<p class="modal-enviar-texto">
                                Le informamos que debido a los costos generados por traslado de mercancía desde otro CEDIS se generará un cargo adicional del 3%.
                            </p>
                        </div>
                        
                    </div>

                    <div class="row m-3">
                        <div class="col-12 col-md-6 col-lg-5 offset-lg-1 mb-3">
                            <button
                                @click="$bvModal.hide('modal-enviarPedido-otros-cedis-confirmacion')"
								:disabled="enviandoPedido"
                                class="link btn btn-block fuente-boton-NoSurtir text-white"
                            >Cancelar</button>
                        </div>
                        <div class="col-12 col-md-6 col-lg-5 mb-4">
                            <button
                                @click="surtir(true)"
								:disabled="enviandoPedido"
                                class="link btn btn-block fuente-boton-SiSurtir text-white"
                            >Aceptar	</button>
                        </div>
                    </div>
                </div>
            </template>
            <template v-slot:modal-footer>&nbsp;</template>
        </b-modal>

        <!-- enviar pedido mi cedis -->
		<b-modal
				centered
				header-class="fondo-modal"
				id="modal-confirmacion-enviarPedido"
				no-close-on-backdrop
				hide-footer
				hide-header-close
				size="md"
				>
				<div class="mt-3">
					<div v-if="mostrarFacturarPublicoGeneral" class="row mb-3">
						<div class="col-12 modal-enviar-texto d-flex text-center align-items-center justify-content-center vertical-align-center mt-2">
								<span class=" text-right">Facturar a: </span>
								
									<b-form-select class="w-75 ml-1 modal-enviar-texto"  v-model="facturarPublicoGeneral" 
													:options="opcionesFacturarPublicoGeneral"></b-form-select>
								
						</div>
					</div>
					<div class="row mb-3">
						<div class="col-12">
							<p class="modal-enviar-texto text-center">
							¿Desea enviar el pedido?</p>
						</div>
					</div>
					<div class="row m-2">
						<div class="col-12 col-md-6 col-lg-5 offset-lg-1 mb-3">
							
							<button
								@click="modalConfirmacionEnviarPedido(false)"
								:disabled="enviandoPedido"
								class="link btn btn-block fuente-boton-NoSurtir text-white"
							>No</button>
						</div>
						<div class="col-12 col-md-6 col-lg-5 mb-4">
							<button
								@click="surtir(false)"
								:disabled="enviandoPedido"
								class="link btn btn-block fuente-boton-SiSurtir text-white"
							>Sí</button>
						</div>
					</div>
				</div>
		</b-modal>
		
		<div v-if="excel">
			<div class="mx-3">
				<hr>
			</div>
			<div class="row m-1 fuente-tabla-producto font-weight-bold pb-3 div-fijo-renglones ">
			
				<div class="col-6 col-md-5 col-lg-7 col-xl-9">
					Renglones:
					{{rowsPedidoExcel}}
				</div>
				<div class="col-6 col-md-7 col-lg-5 col-xl-3">
					Artículos: {{articulosPedidoExcel}}
				</div>
			</div>
            <div class="row ">
				<div class="col-8"></div>
                <div class="col-4">
                    <div class="mr-3">
                        <div class="row text-right">
                            <div class="col-8">
                                <span class="fuente-divfijo-texto">Subtotal:</span>
                            </div>
                            <div class="col-4">
                                <span class="fuente-divfijo-texto">{{subtotal | format-number("$0,0.00")}}</span>
                            </div>
                        </div>
                        <div class="row text-right">
                            <div class="col-8">
                                <span class="impuestos-ieps-tabla p-0 m-0 mr-1">&nbsp;</span>
                                <span class="fuente-divfijo-texto">IEPS:</span>
                            </div>
                            <div class="col-4">
                                <span class="fuente-divfijo-texto">{{ieps | format-number("$0,0.00")}}</span>
                            </div>
                        </div>
                        <div class="row text-right">
                            <div class="col-8">
                                <span class="impuestos-iva-tabla p-0 m-0 mr-1">&nbsp;</span>
                                <span class="fuente-divfijo-texto">IVA:</span>
                            </div>
                            <div class="col-4">
                                <span class="fuente-divfijo-texto">{{iva | format-number("$0,0.00")}}</span>
                            </div>
                        </div>
                        <div class="row text-right pb-2">
                            <div class="col-8">
                                <span class="fuente-divfijo-total">Total:</span>
                            </div>
                            <div class="col-4">
                                <span class="fuente-divfijo-total">{{total | format-number("$0,0.00")}}</span>
                            </div>
                        </div>
                        <div class="d-flex justify-content-end mb-4 mt-2" v-if="!this.soloConsulta()">
                                <button @click="enviarPedidoDesdeExcel"
									:disabled="botonEnviar"
                                    class="btn btn-sm btn-block fuente-boton-enviar text-white"
                                >Enviar pedido</button>
                        </div>
                    </div>
                </div>
            </div>
		</div>
		<div class="row div-fijo" v-else>
			<div class="col-12 p-0 m-0">
				<div class="container">
					<div class="row text-right">
						<div class="col-5 offset-1">
							<span class="fuente-divfijo-texto">Subtotal:</span>
						</div>
						<div class="col-5">
							<span class="fuente-divfijo-texto">{{subtotal | format-number("$0,0.00")}}</span>
						</div>
					</div>
					<div class="row text-right">
						<div class="col-5 offset-1">
							<span class="impuestos-ieps-tabla p-0 m-0 mr-1">&nbsp;</span>
							<span class="fuente-divfijo-texto">IEPS:</span>
						</div>
						<div class="col-5">
							<span class="fuente-divfijo-texto">{{ieps | format-number("$0,0.00")}}</span>
						</div>
					</div>
					<div class="row text-right">
						<div class="col-5 offset-1">
							<span class="impuestos-iva-tabla p-0 m-0 mr-1">&nbsp;</span>
							<span class="fuente-divfijo-texto">IVA:</span>
						</div>
						<div class="col-5">
							<span class="fuente-divfijo-texto">{{iva | format-number("$0,0.00")}}</span>
						</div>
					</div>
					<div class="row text-right pb-2">
						<div class="col-5 offset-1">
							<span class="fuente-divfijo-total">Total:</span>
						</div>
						<div class="col-5">
							<span class="fuente-divfijo-total">{{total | format-number("$0,0.00")}}</span>
						</div>
					</div>

					<div class="row pb-1" v-if="!this.soloConsulta()">
						<div class="col-10 offset-1">
							<!-- <button
								@click="modalConfirmacionEnviarPedido(true)"
								class="link btn btn-sm btn-block fuente-boton-eliminar text-white"
								v-if="!carritoVacio"
							>Enviar pedido</button> -->
								
							
							<button
								@click="modalEnviarPedidoOpen"
								class="link btn btn-sm btn-block fuente-boton-eliminar text-white"
								v-if="totalArticulos > 0"
							>Enviar pedido</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import PmInputNumber from "@/components/clientes/InputNumber"
	import servicio from "@/services/servicio-carrito"
	// import _ from 'lodash'

	export default {
        props:["excel","articulosExcel","rutaCargado"],
		data() {
			return {
				ocultarBoton: false,
				mostrarEliminar: false,
				carritoVacio: false,
				articulos: [],
				articuloSeleccionado: [],
				cedisCliente: [],
				cedisExternos: [],
				cantidadAnterior: 0,
				mostrarModalArticulos:false,
				opcionesFacturarPublicoGeneral: [
					{value:false, text: this.usuarioGlobal().name},
					{value:true, text:'Público en general'}
				],
				facturarPublicoGeneral:false,
				mostrarFacturarPublicoGeneral: false,
				enviandoPedido:false,
				forzarPOC: false
			}
		},
		components: {
			PmInputNumber,
		},
		mounted() {
            if(this.excel){
                this.articulos=this.articulosExcel
            }
            else{
                this.carritoConsultar()
                this.toggleBtnEnviaPedido()
                this.obtenerNotificaciones()
            }
			this.facturarPublicoGeneralMethod()

			const localForzarPOC = localStorage.getItem('forzarPOC');
			if (localForzarPOC !== null) {
				this.forzarPOC = localForzarPOC === 'true'; 
			}
		},
		computed: {
            articulosPedidoExcel(){
				let total = 0
				this.articulos.forEach((item) => {
					total += parseInt(item.cantidad)
				})
				return total
            },
			botonEnviar(){
				return this.totalArticulos == 0 ? true : false
			},
			rowsPedidoExcel(){
				return this.articulos.length
			},
			subtotal() {
				let subtotal = 0
				this.articulos.forEach((item) => {
					subtotal += item.cantidad * ( item.ofertado ? item.precioOfertado : (item.remate ? item.precioRemate : (item.buenFin ? item.precioBuenFin : item.precio)) )
				})
				return subtotal
			},
			ieps() {
				let ieps = 0
				this.articulos.forEach((item) => {
					ieps += item.cantidad * ( item.ofertado ? item.precioOfertado : (item.remate ? item.precioRemate : (item.buenFin ? item.precioBuenFin : item.precio))) * (item.ieps / 100 )
				})
				return ieps
			},
			iva() {
				let iva = 0
				this.articulos.forEach((item) => {
					iva +=
						item.cantidad * ( item.ofertado ? item.precioOfertado : (item.remate ? item.precioRemate : (item.buenFin ? item.precioBuenFin : item.precio))) * (1 + item.ieps / 100) * (item.iva / 100 )
				})
				return iva
			},
			total() {
                let total=0
				total = this.subtotal + this.ieps + this.iva                
				this.$emit("total", total);
				return total
			},
			totalArticulos() {
				let totalArticulos = 0
				this.articulos.forEach((item) => {
					totalArticulos += item.cantidad 
				})
				return totalArticulos
			},
		},
		methods: {
			pressTab(indexSelected){
				
				if(indexSelected < this.articulos.length-1){
					indexSelected++
					this.$refs['input'+indexSelected][0].$refs['inputCantidad'].focus()
				}
			},
            async enviarPedidoDesdeExcel(){
				var articulosCedisExternos = await this.articulos.filter(x => x.cantidad > 0).filter(	item => item.cantidad > item.existenciaMiCedis )
				if(articulosCedisExternos.length > 0){

					if (!this.forzarPOC)
					{
						console.log('otros cedis')
						this.crearArrayCedisExternos(articulosCedisExternos)
					}
					else{
						//surtir sin la pregunta
						this.surtir(true)
					}
				}
				else{
                    console.log('mi cedis')
					this.modalConfirmacionEnviarPedido(true)
				}
			}, 
			facturarPublicoGeneralMethod(){
				servicio.FacturarPublicoGeneral()
					.then( r => {
						this.mostrarFacturarPublicoGeneral = r.value
					})
					.catch( error => {
						console.log('facturarPublicoGeneral', error)
					})
			},
			async crearArrayCedisExternos(articulosCedisExternos){
				this.cedisExternos = []
				await articulosCedisExternos.forEach(element => {
					this.cedisExternos.push(
						{
							codArticulo: element.codArticulo,
							nombreArticulo: element.descripcion,
							laboratorio: element.laboratorio,
							cantidad: element.cantidad - element.existenciaMiCedis	
						}
					)
				});

				this.$bvModal.show("modal-confirmacion-enviarPedido-otros-cedis")
			},
			modalConfirmacionEnviarPedido(mostrar){
				if(mostrar==true){
					//this.mostrarModalArticulos = false
					this.$bvModal.show("modal-confirmacion-enviarPedido")
				}
				else{
					this.$bvModal.hide("modal-confirmacion-enviarPedido")
					this.$nextTick(()=>{
						if(this.excel){
							this.mostrarModalArticulos = true
						}
					})
				}
			},
			modalEnviarPedidoOpen() {
				servicio
					.consultarCedis()
					.then((r) => {

						this.cedisCliente = r.data.cedisCliente
						this.cedisExternos = r.data.cedisExternos

						if(this.cedisExternos.length>0){

							if (!this.forzarPOC){
								this.$bvModal.show("modal-confirmacion-enviarPedido-otros-cedis")
							}else{
								//manda a llamar el metodo que sale al dar aceptar en el siguiente
								this.surtir(true)
							}
						}
						else{
							//muestra modal si es un pedido que se surtira solo en el cedis del cliente
							this.modalConfirmacionEnviarPedido(true)
						}			
					})
					.catch((e) => {
						console.log(e)
					})
			},
			modalEnviarPedidoClose() {
				this.$bvModal.hide("modal-enviarPedido-otros-cedis")
			},	
			modalEnviarPedidoConfirmacionClose(){
				this.$bvModal.hide("modal-enviarPedido-otros-cedis-confirmacion")
			},
			mostrarEliminarOpen(articulo) {
				this.articuloSeleccionado = articulo
				
				let msgText = '¿Desea quitar del carrito el producto: ' + articulo.descripcion + '?'

				this.$msg.question( msgText )
				.then((result) => {
					if (result.isConfirmed) {
						this.eliminarArticulo()
					}
				})

				//this.$bvModal.show("modal-eliminar")
			},
			mostrarEliminarTodosOpen() {
				if (!this.carritoVacio) {
					let msgText = '¿Desea limpiar el carrito de compras?'

					this.$msg.question( msgText )
					.then((result) => {
						if (result.isConfirmed) {
							this.vaciarCarrito()
						}
					})
				}
			},
			modalEliminarClose() {

				this.$bvModal.hide("modal-eliminar")
			},
			mostrarColumnaEliminar() {
				this.mostrarEliminar = !this.mostrarEliminar
			},
			// carritoModificarCantidadDebounced: _.debounce(async function (articulo) {
					
			// 	this.ocultarBoton = true;  // Deshabilitar el control antes de la ejecución
			// 	try {
			// 		await this.carritoModificarCantidad(articulo.codArticulo, articulo.cantidad);
			// 		this.carritoConsultar();  // Actualiza el carrito
			// 	} finally {
					
			// 		this.ocultarBoton = false;  // Habilitar el control nuevamente después de la ejecución
			// 		console.log(this.ocultarBoton)
			// 	}
			// }, 500), 
			async aumentar(articulo) {
				articulo.cantidad++

                if(!this.excel){
					
                    // await this.carritoModificarCantidad(articulo.codArticulo, articulo.cantidad).then(() => {
					// 	this.carritoConsultar()
					// })
					
					// this.carritoModificarCantidadDebounced(articulo)

					this.ocultarBoton = true;  // Deshabilitar el control antes de la ejecución
					try {
						await this.carritoModificarCantidad(articulo.codArticulo, articulo.cantidad);
						this.carritoConsultar();  // Actualiza el carrito
					} finally {
						this.ocultarBoton = false;  // Habilitar el control nuevamente después de la ejecución
					}
					// setTimeout(() => {
					// 	this.carritoConsultar()
					// }, 500)

				}
			},
			async disminuir(articulo) {
				this.cantidadAnterior = articulo.cantidad
				articulo.cantidad--

				if (articulo.cantidad <= 0){

					let msgText = '¿Desea quitar del carrito el producto: ' + articulo.descripcion + '?'

					const result = await this.$msg.question( msgText )
					
					if (result.isConfirmed) {
						const index = this.articulos.findIndex(
							(item) => item.codArticulo === articulo.codArticulo
						)
						this.articulos.splice(index, 1)
						if(!this.excel){
							// this.carritoModificarCantidad(articulo.codArticulo, articulo.cantidad).then(() => {
							// 	this.carritoConsultar()
							// })
							// this.carritoModificarCantidadDebounced(articulo)
							this.ocultarBoton = true;  // Deshabilitar el control antes de la ejecución
							try {
								await this.carritoModificarCantidad(articulo.codArticulo, articulo.cantidad);
								this.carritoConsultar();  // Actualiza el carrito
							} finally {
								
								this.ocultarBoton = false;  // Habilitar el control nuevamente después de la ejecución
								console.log(this.ocultarBoton)
							}
						}
					}
					else{
						articulo.cantidad = this.cantidadAnterior
					}
				}
				else{
                    if(!this.excel){
                        // await this.carritoModificarCantidad(articulo.codArticulo, articulo.cantidad).then(() => {
						// 	this.carritoConsultar()
						// })
						// this.carritoModificarCantidadDebounced(articulo)
						this.ocultarBoton = true;  // Deshabilitar el control antes de la ejecución
						try {
							await this.carritoModificarCantidad(articulo.codArticulo, articulo.cantidad);
							this.carritoConsultar();  // Actualiza el carrito
						} finally {
							
							this.ocultarBoton = false;  // Habilitar el control nuevamente después de la ejecución
							console.log(this.ocultarBoton)
						}
                    }
				}
				
				
				//console.log('articulo', articulo.codArticulo)
				
			},
			async agregarCantidad(articulo, cantidadAnterior) {	
				
				if (articulo.cantidad == "" || articulo.cantidad == 0) {
					articulo.cantidad = 0
					let msgText = '¿Desea quitar del carrito el producto: ' + articulo.descripcion + '?'

					const result = await this.$msg.question( msgText )
					if (result.isConfirmed) {
						const index = this.articulos.findIndex(
							(item) => item.codArticulo === articulo.codArticulo
						)
						this.articulos.splice(index, 1)

						if(!this.excel){
							// this.carritoModificarCantidad(articulo.codArticulo, articulo.cantidad).then(() => {
							// 	this.carritoConsultar()
							// })
							// this.carritoModificarCantidadDebounced(articulo)
							this.ocultarBoton = true;  // Deshabilitar el control antes de la ejecución
							try {
								await this.carritoModificarCantidad(articulo.codArticulo, articulo.cantidad);
								this.carritoConsultar();  // Actualiza el carrito
							} finally {
								
								this.ocultarBoton = false;  // Habilitar el control nuevamente después de la ejecución
								console.log(this.ocultarBoton)
							}
						}
					}
					else{
						articulo.cantidad = cantidadAnterior
					}
				}
				else{
                    if(!this.excel){
                        // this.carritoModificarCantidad(articulo.codArticulo, articulo.cantidad).then(() => {
						// 	this.carritoConsultar()
						// })
						// this.carritoModificarCantidadDebounced(articulo)
						this.ocultarBoton = true;  // Deshabilitar el control antes de la ejecución
						try {
							await this.carritoModificarCantidad(articulo.codArticulo, articulo.cantidad);
							this.carritoConsultar();  // Actualiza el carrito
						} finally {
							
							this.ocultarBoton = false;  // Habilitar el control nuevamente después de la ejecución
							console.log(this.ocultarBoton)
						}
                    }
				}
			},
			eliminarArticulo() {
                if(!this.excel){
                    this.carritoModificarCantidad(
                        this.articuloSeleccionado.codArticulo,
                        0
                    ).then(() => {
                        const index = this.articulos.findIndex(
                            (item) => item.codArticulo === this.articuloSeleccionado.codArticulo
                        )
                        this.articulos.splice(index, 1)
                        this.toggleBtnEnviaPedido()
                    })
                    this.$bvModal.hide("modal-eliminar")
                }
                else{
                    const index = this.articulos.findIndex(
                        (item) => item.codArticulo === this.articuloSeleccionado.codArticulo
                    )
                    this.articulos.splice(index, 1)
                }
			},
			abrirModalConfirmacion(){				
				this.$bvModal.show("modal-enviarPedido-otros-cedis-confirmacion")
			},
			abrirModalEnvioPedidoOtrosCedis(){
				this.$bvModal.hide("modal-confirmacion-enviarPedido-otros-cedis")
				this.$bvModal.show("modal-enviarPedido-otros-cedis")
			},
			toggleBtnEnviaPedido() {
				this.carritoConsultarCantidad()
					.then((r) => {
						let totalCarrito = r.data
						this.carritoVacio = totalCarrito == 0 ? true : false
						this.$nextTick(()=>{
							//let tabla = this.$refs.tablaCarrito
							//this.$floatThead.ini(tabla)
						})
					})
					.catch((e) => {
						console.log(e)
					})
			},
			carritoConsultar() {
				this.$loading(true)
				servicio
					.consultar()
					.then((r) => {
						this.$loading(false)
						this.articulos = r.data

						console.log('Entro!!')
					})
					.catch((e) => {
						this.$loading(false)
						console.log(e)
					})
			},
			async surtir(surtirEnVariosCedis) {
				try{
					this.$loading(true)
					this.enviandoPedido=true
					if(this.excel){
						let result = await servicio.surtirDesdeExcel(surtirEnVariosCedis,this.facturarPublicoGeneral, this.rutaCargado, this.articulos.filter(x => x.cantidad > 0))
						if(result.value){
							this.$swal.fire({
								text: result.message,
								icon: "success",
							})				

							// this.$bvModal.hide("modal-enviarPedido-otros-cedis-confirmacion")
							this.$bvModal.hide("modal-enviarPedido-otros-cedis")
							this.$bvModal.hide("modal-articulos-excel")
							this.togleMenu()	
						}
						else {
							this.$swal.fire({
								text: result.message,
								icon: "warning",
							})
						}							
					}
					else{
						let result = await servicio.surtir(surtirEnVariosCedis, this.facturarPublicoGeneral)

						console.log("result surtir",result)
						if (result.value) {
							this.$swal.fire({
								text: result.message,
								icon: "success",
							})
							
							// this.$bvModal.hide("modal-enviarPedido-otros-cedis-confirmacion")
							this.$bvModal.hide("modal-enviarPedido-otros-cedis")
							this.$bvModal.hide("modal-articulos-excel")
							this.togleMenu()
						} else {
							this.$swal.fire({
								text: result.message,
								icon: "warning",
							})
						}
					}		
					this.enviandoPedido=false
					this.$loading(false)
				}
				catch(error){		
					console.log(error)
					this.enviandoPedido=false
					this.$loading(false)
				}
			},
			verDetalle(index) {
				this.$router.push({ path: `/clientes/detalle-producto/${index}` })
			},
			togleMenu() {
				this.$emit('togleMenu', 1)
				if(this.$router.currentRoute.path === '/clientes/estatus-de-pedido'){
					this.$router.go({ path: `/clientes/estatus-de-pedido`})
				}
				else{
					this.$router.push({ path: `/clientes/estatus-de-pedido` })
                }
			},
			vaciarCarrito() {
				this.$loading(true)
				servicio
					.vaciar()
					.then((r) => {
						if (r.data.value) {
                            this.articulos=[]
                            //this.carritoConsultarCantidad()
                            this.carritoConsultar()
                            this.carritoVacio = true
                            this.$emit('actualizarTotalCarrito')
						}
						this.$loading(false)
					})
					.catch((e) => {
						console.log(e)
					})
			},
		},
	}
</script>
<style scoped>
	.custom-file-upload {
		display: inline-block;
		cursor: pointer;
	}

	.div-fijo {
		position: fixed;
		bottom: 65px;
		right: 25px;
		width: 300px;
		background-color: #ebebeb;
	}
	.circle-trash {
		background-color: #4c79e4 !important;
		border-radius: 50%;
	}
	.circle-trash-vaciar-carrito:hover {
		background-color: #4c79e4 !important;
		border-radius: 50%;
	}
	.span-eliminar {
		background-color: #0a2157 !important;
	}
	.icon-trash {
		color: var(--color-blanco);
	}
	.td-center {
		vertical-align: middle !important;
		cursor: pointer;
	}

	/* Titulo */
	.Titulo {
		font-family: "Open Sans";
		color: var(--bg-menu-blue);
		font-weight: bold;
	}

	/* Impuestos */
	.fondo-impuestos {
		background-color: var(--color-blanco) !important;
	}
	.impuestos-texto {
		font-family: "Open Sans";
		color: var(--bg-menu-blue);
	}
	.impuestos-iva {
		/* background-color: #ff8800 !important;
												border-radius: 10rem;
												display: inline-block;
												line-height: 1;
												white-space: nowrap;
												vertical-align: baseline;
												width: 30px;
												height: 9px; */

		display: inline-block;
		width: 0.5rem;
		height: 0.5rem;
		border-radius: 50%;
		background: #ff8800 !important;
		justify-content: center;
		align-items: center;
		text-align: center;
	}
	.impuestos-ieps {
		display: inline-block;
		width: 0.5rem;
		height: 0.5rem;
		border-radius: 50%;
		background: #0088ff !important;
		justify-content: center;
		align-items: center;
		text-align: center;
		/* background-color: #0088ff !important;
												border-radius: 10rem;
												display: inline-block;
												line-height: 1;
												white-space: nowrap;
												vertical-align: baseline;
												width: 30px;
												height: 9px; */
	}

	/* Saldo */
	.fondo-saldo {
		background-color: var(--color-blanco) !important;
	}
	.saldo-texto {
		font-family: "Open Sans";
		font-weight: 700;
		color: var(--bg-menu-blue);
	}
	.saldo-monto {
		font-family: "Open Sans";
		font-weight: 600;
		color: var(--bg-menu-blue);
	}

	/* Borrar */
	.fondo-borrar {
		background-color: var(--bg-menu-blue) !important;
	}
	.borrar-texto {
		font-family: "Open Sans";
	}

	/* Tabla articulos */
	.fondo-tabla {
		background-color: var(--color-blanco) !important;
	}
	.fondo-tabla-head {
		background-color: #335198 !important;
	}
	.fuente-tabla-head {
		font-family: "Open Sans";
		color: var(--color-blanco);
	}
	.fuente-tabla-producto {
		font-family: "Open Sans";
		color: var(--bg-menu-blue);
	}
	.impuestos-iva-tabla {
		display: inline-block;
		width: 0.5rem;
		height: 0.5rem;
		border-radius: 50%;
		background: #ff8800 !important;
		justify-content: center;
		align-items: center;
		text-align: center;
		/* background-color: #ff8800 !important;
												border-radius: 10rem;
												display: inline-block;
												line-height: 1;
												white-space: nowrap;
												vertical-align: baseline;
												width: 25px;
												height: 5px; */
	}
	.impuestos-ieps-tabla {
		display: inline-block;
		width: 0.5rem;
		height: 0.5rem;
		border-radius: 50%;
		background: #0088ff !important;
		justify-content: center;
		align-items: center;
		text-align: center;
		/* background-color: #0088ff !important;
												border-radius: 10rem;
												display: inline-block;
												line-height: 1;
												white-space: nowrap;
												vertical-align: baseline;
												width: 25px;
												height: 5px; */
	}

	.producto-sin-derecho-devolucion {
		display: inline-block;
		width: 0.5rem;
		height: 0.5rem;
		border-radius: 50%;
		background: #ff0000 !important;
		justify-content: center;
		align-items: center;
		text-align: center;
		/* background-color: #0088ff !important;
												border-radius: 10rem;
												display: inline-block;
												line-height: 1;
												white-space: nowrap;
												vertical-align: baseline;
												width: 25px;
												height: 5px; */
	}

	.producto-con-derecho-devolucion {
		display: inline-block;
		width: 0.5rem;
		height: 0.5rem;
		border-radius: 50%;
		background: #4fc147 !important;
		justify-content: center;
		align-items: center;
		text-align: center;
		/* background-color: #0088ff !important;
												border-radius: 10rem;
												display: inline-block;
												line-height: 1;
												white-space: nowrap;
												vertical-align: baseline;
												width: 25px;
												height: 5px; */
	}

	.texto-producto-sin-devolucion {
		margin-left: -1px;
		margin-top: 1px;
		color: #ff0000;
		font-weight: bold;
	}

	.texto-producto-con-devolucion {
		margin-left: -1px;
		margin-top: 1px;
		color: #4fc147;
		font-weight: bold;
	}

	.fuente-tabla-laboratorio {
		font-family: "Open Sans";
		color: var(--bg-menu-blue);
	}
	.fuente-tabla-precio {
		font-family: "Open Sans";
		color: var(--bg-menu-blue);
	}
	.fuente-tabla-sincargo {
		font-family: "Open Sans";
		color: var(--bg-menu-blue);
	}
	.fuente-tabla-importe {
		font-family: "Open Sans";
		color: var(--bg-menu-blue);
	}

	.fuente-boton-enviar {
		background-color: #335198 !important;
		width: 200px;
	}
	.fuente-boton-enviar:hover {
		background-color: #273c6e !important;
	}
	/* Modal */
	.modal-titulo {
		font-family: "Open Sans";
		color: var(--bg-menu-blue);
		font-weight: 600;
	}
	.modal-articulo {
		font-family: "Open Sans";
		color: #f1c240 !important;
		font-weight: 600;
	}
	.fuente-boton-cancelar {
		background-color: #bcc1cf !important;
	}
	.fuente-boton-cancelar:hover {
		background-color: #a0a6b7 !important;
	}
	.fuente-boton-eliminar {
		background-color: #335198 !important;
	}
	.fuente-boton-eliminar:hover {
		background-color: #273c6e !important;
	}
	.fuente-boton-NoSurtir {
		background-color: #bcc1cf !important;
	}
	.fuente-boton-NoSurtir:hover {
		background-color: #a0a6b7 !important;
	}
	.fuente-boton-SiSurtir {
		background-color: #f1c240 !important;
	}
	.fuente-boton-SiSurtir:hover {
		background-color: #ff8800 !important;
	}

	/* modal enviar */
	.modal-enviar-titulo {
		font-family: "Open Sans";
		font-weight: 600;
	}
	.modal-enviar-subtitulo {
		font-family: "Open Sans";
		color: var(--bg-menu-blue);
		font-weight: 600;
	}
	.modal-enviar-encabezado {
		font-family: "Open Sans";
		font-weight: 600;
	}
	.modal-enviar-texto {
		font-family: "Open Sans";
		color: var(--bg-menu-blue);
	}
	.modal-enviar-tabla {
		font-family: "Open Sans";
		color: var(--bg-menu-blue);
		font-weight: 600;
	}
	.modal-enviar-movil {
		font-family: "Open Sans";
		color: var(--bg-menu-blue);
	}

	/* Div flotante */
	.fuente-divfijo-texto {
		font-family: "Open Sans";
		font-weight: 600;
		color: var(--bg-menu-blue);
	}
	.fuente-divfijo-total {
		font-family: "Open Sans";
		font-weight: 700;
		color: var(--bg-menu-blue);
	}
	#tblCarrito th {
        position: sticky; 
        top: 0;
        background: var(--bg-menu-blue);
        color: #FFFFFF;  
		z-index:1;      
    }

	/* xs */
	/* Estos estilos solo se aplicaran hasta el tamaño indicado */
	@media screen and (max-width: 575px) {
		/* Titulo */
		.fuente-titulo {
			font-size: 16px !important;
		}
		/* Impuestos */
		.impuestos-texto {
			font-size: 12px !important;
		}
		/* Saldo */
		.saldo-texto {
			font-size: 16px !important;
		}
		.saldo-monto {
			font-size: 16px !important;
		}
		/* Borrar */
		.borrar-texto {
			font-size: 14px !important;
		}
		/* Tabla articulos */
		.fuente-tabla-head {
			font-size: 14px !important;
		}
		.fuente-tabla-producto {
			font-size: 12px !important;
		}
		.fuente-tabla-laboratorio {
			font-size: 12px !important;
		}
		.fuente-tabla-precio {
			font-size: 14px !important;
		}
		.fuente-tabla-sincargo {
			font-size: 12px !important;
		}
		.fuente-tabla-importe {
			font-size: 14px !important;
		}
		/* Modal */
		.modal-titulo {
			font-size: 16px !important;
		}
		.modal-articulo {
			font-size: 18px !important;
		}
		/* modal enviar */
		.modal-enviar-titulo {
			font-size: 16px !important;
		}
		.modal-enviar-subtitulo {
			font-size: 16px !important;
		}
		.modal-enviar-texto {
			font-size: 14px !important;
		}
		.modal-enviar-tabla {
			font-size: 12px !important;
		}
		.modal-enviar-movil {
			font-size: 12px !important;
		}
		/* Div flotante */
		.div-fijo {
			right: 0;
			left: 0;
			margin: auto;
		}
		.fuente-divfijo-texto {
			font-size: 12px !important;
		}
		.fuente-divfijo-total {
			font-size: 14px !important;
		}
	}

	/* sm */
	/* Estos estilos solo se aplicaran hasta el tamaño indicado */
	@media screen and (min-width: 576px) and (max-width: 767px) {
		/* Titulo */
		.fuente-titulo {
			font-size: 16px !important;
		}
		/* Impuestos */
		.impuestos-texto {
			font-size: 12px !important;
		}
		/* Saldo */
		.saldo-texto {
			font-size: 16px !important;
		}
		.saldo-monto {
			font-size: 16px !important;
		}
		/* Borrar */
		.borrar-texto {
			font-size: 14px !important;
		}
		/* Tabla articulos */
		.fuente-tabla-head {
			font-size: 14px !important;
		}
		.fuente-tabla-producto {
			font-size: 12px !important;
		}
		.fuente-tabla-laboratorio {
			font-size: 12px !important;
		}
		.fuente-tabla-precio {
			font-size: 14px !important;
		}
		.fuente-tabla-sincargo {
			font-size: 12px !important;
		}
		.fuente-tabla-importe {
			font-size: 14px !important;
		}
		/* Modal */
		.modal-titulo {
			font-size: 16px !important;
		}
		.modal-articulo {
			font-size: 18px !important;
		}
		/* modal enviar */
		.modal-enviar-titulo {
			font-size: 16px !important;
		}
		.modal-enviar-subtitulo {
			font-size: 16px !important;
		}
		.modal-enviar-texto {
			font-size: 14px !important;
		}
		.modal-enviar-tabla {
			font-size: 12px !important;
		}
		.modal-enviar-movil {
			font-size: 12px !important;
		}
		/* Div flotante */
		.fuente-divfijo-texto {
			font-size: 12px !important;
		}
		.fuente-divfijo-total {
			font-size: 14px !important;
		}
	}

	/* md */
	/* Solo se aplicaran entre los tamaños indicados */
	@media screen and (min-width: 768px) and (max-width: 991px) {
		/* Titulo */
		.fuente-titulo {
			font-size: 16px !important;
		}
		/* Impuestos */
		.impuestos-texto {
			font-size: 12px !important;
		}
		/* Saldo */
		.saldo-texto {
			font-size: 16px !important;
		}
		.saldo-monto {
			font-size: 16px !important;
		}
		/* Borrar */
		.borrar-texto {
			font-size: 14px !important;
		}
		/* Tabla articulos */
		.fuente-tabla-head {
			font-size: 14px !important;
		}
		.fuente-tabla-producto {
			font-size: 12px !important;
		}
		.fuente-tabla-laboratorio {
			font-size: 12px !important;
		}
		.fuente-tabla-precio {
			font-size: 12px !important;
		}
		.fuente-tabla-sincargo {
			font-size: 12px !important;
		}
		.fuente-tabla-importe {
			font-size: 12px !important;
		}
		/* Modal */
		.modal-titulo {
			font-size: 16px !important;
		}
		.modal-articulo {
			font-size: 18px !important;
		}
		/* modal enviar */
		.modal-enviar-titulo {
			font-size: 16px !important;
		}
		.modal-enviar-subtitulo {
			font-size: 16px !important;
		}
		.modal-enviar-texto {
			font-size: 18px !important;
		}
		.modal-enviar-tabla {
			font-size: 14px !important;
		}
		/* Div flotante */
		.div-fijo {
			right: 38px;
		}
		.fuente-divfijo-texto {
			font-size: 12px !important;
		}
		.fuente-divfijo-total {
			font-size: 14px !important;
		}
	}

	/* lg */
	/* Solo se aplicaran entre los tamaños indicados */
	@media screen and (min-width: 992px) and (max-width: 1199px) {
		/* Titulo */
		.fuente-titulo {
			font-size: 16px !important;
		}
		/* Impuestos */
		.impuestos-texto {
			font-size: 12px !important;
		}
		/* Saldo */
		.saldo-texto {
			font-size: 16px !important;
		}
		.saldo-monto {
			font-size: 16px !important;
		}
		/* Borrar */
		.borrar-texto {
			font-size: 14px !important;
		}
		/* Tabla articulos */
		.fuente-tabla-head {
			font-size: 14px !important;
		}
		.fuente-tabla-producto {
			font-size: 12px !important;
		}
		.fuente-tabla-laboratorio {
			font-size: 12px !important;
		}
		.fuente-tabla-precio {
			font-size: 12px !important;
		}
		.fuente-tabla-sincargo {
			font-size: 12px !important;
		}
		.fuente-tabla-importe {
			font-size: 12px !important;
		}
		/* Modal */
		.modal-titulo {
			font-size: 16px !important;
		}
		.modal-articulo {
			font-size: 18px !important;
		}
		/* modal enviar */
		.modal-enviar-titulo {
			font-size: 16px !important;
		}
		.modal-enviar-subtitulo {
			font-size: 16px !important;
		}
		.modal-enviar-texto {
			font-size: 18px !important;
		}
		.modal-enviar-tabla {
			font-size: 14px !important;
		}
		/* Div flotante */
		.div-fijo {
			right: 38px;
		}
		.fuente-divfijo-texto {
			font-size: 12px !important;
		}
		.fuente-divfijo-total {
			font-size: 14px !important;
		}
	}

	/* xl */
	/* Los estilos aqui contenidos solo se aplicaran a partir del tamaño de pantalla indicado */
	@media screen and (min-width: 1200px) {
		/* Titulo */
		.fuente-titulo {
			font-size: 16px !important;
		}
		/* Impuestos */
		.impuestos-texto {
			font-size: 12px !important;
		}
		/* Saldo */
		.saldo-texto {
			font-size: 16px !important;
		}
		.saldo-monto {
			font-size: 16px !important;
		}
		/* Borrar */
		.borrar-texto {
			font-size: 14px !important;
		}
		/* Tabla articulos */
		.fuente-tabla-head {
			font-size: 14px !important;
		}
		.fuente-tabla-producto {
			font-size: 12px !important;
		}
		.fuente-tabla-laboratorio {
			font-size: 12px !important;
		}
		.fuente-tabla-precio {
			font-size: 12px !important;
		}
		.fuente-tabla-sincargo {
			font-size: 12px !important;
		}
		.fuente-tabla-importe {
			font-size: 12px !important;
		}
		/* Modal */
		.modal-titulo {
			font-size: 16px !important;
		}
		.modal-articulo {
			font-size: 18px !important;
		}
		/* modal enviar */
		.modal-enviar-titulo {
			font-size: 16px !important;
		}
		.modal-enviar-subtitulo {
			font-size: 16px !important;
		}
		.modal-enviar-texto {
			font-size: 18px !important;
		}
		.modal-enviar-tabla {
			font-size: 14px !important;
		}
		/* Div flotante */
		.div-fijo {
			right: 38px;
		}
		.fuente-divfijo-texto {
			font-size: 12px !important;
		}
		.fuente-divfijo-total {
			font-size: 14px !important;
		}
	}
</style>